import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  Inject,
  NO_ERRORS_SCHEMA,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { CommonService } from './shared/commonService';
import { TranslationService } from './i18n/translation.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationModule } from './i18n/translation.module';
import { locale as enLang } from './i18n/languages/en';
import { locale as esLang } from './i18n/languages/es';
import { locale as ptLang } from './i18n/languages/pt';
import { DomSanitizer, Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppComponent implements OnInit {
  title = 'Unbrid';
  appLoaded: boolean = true;
  language: any = 'en';
  META_DESCRIPTION: any = '';
  constructor(
    private translationService: TranslationService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService
  ) {
    this.translationService.loadTranslations(enLang, esLang, ptLang);
    this.commonService.changeLanguage.asObservable().subscribe((value: any) => {
      this.translationService.setLanguage(value);
      this.translationService
        .translateKeyLang('HOME.META_DESCRIPTION', value)
        .then((resp: any) => {
          this.meta.addTag({ name: 'description', content: resp });
          this.meta.addTag({ property: 'og:description', content: resp });
        });
    });
  }

  ngOnInit(): void {
  }
}
